import API from "../../api";
import moment from "@/utils/moment";
import eventHelper from "@/utils/helpers/event";
import { event } from "vue-analytics";
import { eventBus } from "@/eventBus.js";
import newOrderHelper from "@/utils/helpers/newOrder";

const SET_ADDRESS = "SET_ADDRESS";
const SET_TO_BE = "SET_TO_BE";
const SET_PROFESSIONAL = "SET_PROFESSIONAL";
const SET_PROFESSIONALS_AVAILABLE = "SET_PROFESSIONALS_AVAILABLE";
const SET_ORDERS_WITH_DISCOUNT = "SET_ORDERS_WITH_DISCOUNT";
const SET_EVENT = "SET_EVENT";
const SET_DAY = "SET_DAY";
const SET_STARTS_AT = "SET_STARTS_AT";
const SET_ENDS_AT = "SET_ENDS_AT";
const SET_ADDITIONAL_INFORMATIONS = "SET_ADDITIONAL_INFORMATIONS";
const SET_USE_MY_PRODUCTS = "SET_USE_MY_PRODUCTS";
const SET_PRICE = "SET_PRICE";
const SET_DISCOUNTED_PRICE = "SET_DISCOUNTED_PRICE";
const SET_WONT_HAVE_INSTANT_SUPPORT = "SET_WONT_HAVE_INSTANT_SUPPORT";
const RESET_STATE = "RESET_STATE";

const getDefaultState = () => {
  return {
    address: null,
    to_be: null,
    professional: null,
    professionals_available: null,
    orders_with_discount: null,
    event: null,
    day: null,
    starts_at: null,
    ends_at: null,
    price: null,
    discounted_price: null,
    additional_informations: "",
    use_my_products: false,
    accept_wont_have_instant_support: false
  };
};

export default {
  namespaced: true,

  state: { ...getDefaultState() },

  actions: {
    setAddress({ commit, dispatch, rootState }, payload) {
      try {
        let closedCities = rootState.addresses.closedCities;
        let cityName = payload ? payload.district.city.display_name : "";

        if (closedCities.includes(cityName)) {
          commit("SET_ADDRESS", null);
          throw `A nossa operação em ${cityName} foi encerrada :(`;
        }

        commit("SET_ADDRESS", payload);
        dispatch("setToBe", null);
      } catch (e) {
        throw e;
      }
    },

    setToBe({ commit, dispatch }, payload) {
      event("cliente", "click", `Compra:Escolha:${payload}`);

      commit("SET_TO_BE", payload);
      payload === "professional"
        ? dispatch("setProfessionalsAvailable", null)
        : dispatch("setDay", null);
    },

    setDay({ commit, dispatch, state }, payload) {
      commit("SET_DAY", payload);
      dispatch("setStartsAt", null);
    },

    setStartsAt({ commit, dispatch }, payload) {
      commit("SET_STARTS_AT", payload);
      dispatch("setEndsAt", null);
    },

    setEndsAt({ commit, dispatch, state }, payload) {
      commit("SET_ENDS_AT", payload);
      if (state.to_be === "schedule") {
        dispatch("setProfessionalsAvailable", null);
        dispatch("professionalsSuggestion/setAvailableEvents", null, {
          root: true
        });
      }
      dispatch("getPrice");
    },

    setProfessionalsAvailable({ commit, dispatch, state }, professionals) {
      if (state.to_be === "professional" && professionals) {
        professionals = professionals.map(el => {
          el.account.schedule.events = el.account.schedule.events.filter(
            event => {
              if (eventHelper.isHoliday(event)) return false;
              if (eventHelper.checkSleepingTime(event)) return false;

              let validInitialHour = eventHelper.getValidInitialHour(event);
              event.starts_at = moment(event.starts_at)
                .hour(validInitialHour)
                .toDate();

              return true;
            }
          );

          return el;
        });

        professionals = professionals.filter(
          el => el.account.schedule.events.length
        );
      }

      commit("SET_PROFESSIONALS_AVAILABLE", professionals);
      dispatch("setProfessional", null);
    },

    setProfessional({ commit, state, dispatch }, payload) {
      commit("SET_PROFESSIONAL", payload);
      if (state.to_be === "professional") dispatch("setEvent", null);
      else if (payload) dispatch("setEvent", payload.schedule_event);
      dispatch("getPrice");
    },

    setEvent({ commit, state, dispatch }, payload) {
      commit("SET_EVENT", payload);
      if (state.to_be === "professional" && payload)
        dispatch("setDay", payload.starts_at);
      else if (state.to_be === "professional") dispatch("setDay", null);
    },

    setPrice({ commit, dispatch }, payload) {
      commit("SET_PRICE", payload);
    },

    setDiscountedPrice({ commit, state }) {
      let professional = state.professional;
      let canApplyDiscount =
        professional && newOrderHelper.canApplyDiscount(professional.id);

      let discounted_price = canApplyDiscount
        ? newOrderHelper.applyDiscount(state.price)
        : 0;

      commit("SET_DISCOUNTED_PRICE", discounted_price);
    },

    setAdditionalInformations({ commit }, payload) {
      commit("SET_ADDITIONAL_INFORMATIONS", payload);
    },

    setUseMyProducts({ commit }, payload) {
      commit("SET_USE_MY_PRODUCTS", payload);
    },

    getPrice({ state, getters, dispatch }) {
      const calculatePrice = () => {
        let pricing = state.address.district.pricing;
        let duration = getters.duration;

        let price = duration * pricing.price_per_hour + pricing.price;
        let fee = duration * pricing.fee_per_hour + pricing.fee;

        return price + fee;
      };

      let total_price =
        state.address && getters.duration ? calculatePrice() : null;

      dispatch("setPrice", total_price);
      dispatch("setDiscountedPrice");
    },

    resetState({ commit }) {
      commit("RESET_STATE");
    },

    async searchProfessionalsAvailable({ state, getters, commit, dispatch }) {
      try {
        let day = moment(state.day).format("Y-MM-DD ");
        let starts_at = day + state.starts_at;
        let ends_at = day + state.ends_at;
        let days_of_precedence = moment(state.day).diff(moment(), "days") + 1;

        event(
          "cliente",
          "click",
          `Compra:diaespecifico:buscar:duracao=${
            getters.duration
          }:horainicial=${starts_at}:diasdeantecedencia=${days_of_precedence}`
        );

        let res = await API.Professionals.getAvailables({
          data: {
            attributes: {
              district_id: state.address.district.id,
              starts_at,
              ends_at
            }
          }
        });

        event(
          "cliente",
          "click",
          `Compra:diaespecifico:profissional:numerodisponiveis=${
            res.length
          }:cidade=${state.address.district.city.display_name}:bairro=${
            state.address.district.display_name
          }:dia=${moment(state.day).format("DD")}:diadasemana=${moment(
            state.day
          ).format(
            "dddd"
          )}:diasdeantecedencia=${days_of_precedence}:horainicial=${
            state.starts_at
          }:horafinal=${state.ends_at}:duracao=${getters.duration}`
        );

        res.forEach(professional => {
          event(
            "cliente",
            "click",
            `Compra:diaespecifico:profissional:disponivel:nome=${
              professional.account.first_name
            } ${professional.account.last_name}:nota=${
              professional.rating
            }:limpezas=undefined`
          );
        });
        commit("SET_PROFESSIONALS_AVAILABLE", res);
      } catch (e) {
        throw e;
      }
    },

    async create({ rootState, state, dispatch }) {
      try {
        let user = rootState.user.user;
        let day = moment(state.day).startOf("hour");
        let starts_at = day.hour(state.starts_at.substr(0, 2)).toISOString();
        let ends_at = day.hour(state.ends_at.substr(0, 2)).toISOString();

        let data_order = {
          data: {
            type: "orders",
            attributes: {
              starts_at,
              ends_at,
              description: state.additional_informations
            },
            relationships: {
              customer: {
                data: {
                  type: user.accountable.type,
                  id: user.accountable.id
                }
              },
              professional: {
                data: {
                  type: "professionals",
                  id: state.professional.id
                }
              },
              schedule_event: {
                data: {
                  type: "schedule_events",
                  id: state.event.id
                }
              },
              address: {
                data: {
                  type: "addresses",
                  id: state.address.id
                }
              }
            }
          }
        };

        let order = await API.Orders.create(data_order);

        return order;
      } catch (e) {
        throw e;
      }
    },

    async applyProfessionalBeginnerCoupon({ dispatch }, order) {
      try {
        let professionalID = order.professional_id;

        let foundOnList = newOrderHelper.findProfessionalOnList(professionalID);
        if (!foundOnList) return false;

        await dispatch("setOrdersWithDiscount", professionalID);

        let isApplicable = newOrderHelper.canApplyDiscount(professionalID);
        if (!isApplicable) {
          eventBus.$toasted.error(
            "Ah não! O desconto não foi aplicado pois o profissional atingiu o limite de pedidos com o cupom!",
            { duration: 20000 }
          );
          return false;
        }

        let data = {
          order: order.id,
          coupon: newOrderHelper.getCouponID()
        };

        return await dispatch("orders/applyCoupon", data, { root: true });
      } catch (e) {
        throw e;
      }
    },

    confirmPrice({ dispatch, getters, state }) {
      event("cliente", "click", `Compra:professional:confirmar`);
    },

    async setOrdersWithDiscount({ commit }, professionalID) {
      try {
        let res = await API.Dataclips.getProfessionalsInitialCouponDiscount();
        commit("SET_ORDERS_WITH_DISCOUNT", res);
      } catch (e) {
        throw e;
      }
    },

    acceptWontHaveInstantSupport({ commit }) {
      commit("SET_WONT_HAVE_INSTANT_SUPPORT", true);
    },

    rejectWontHaveInstantSupport({ state, dispatch }) {
      state.to_be === "professional"
        ? dispatch("setEvent", null)
        : dispatch("setDay", null);
    }
  },

  mutations: {
    [SET_ADDRESS](state, payload) {
      state.address = payload;
    },
    [SET_TO_BE](state, payload) {
      state.to_be = payload;
    },
    [SET_PROFESSIONAL](state, payload) {
      state.professional = payload;
    },
    [SET_PROFESSIONALS_AVAILABLE](state, payload) {
      state.professionals_available = payload;
    },
    [SET_ORDERS_WITH_DISCOUNT](state, payload) {
      state.orders_with_discount = payload;
    },
    [SET_EVENT](state, payload) {
      state.event = payload;
    },
    [SET_DAY](state, payload) {
      state.day = payload;
    },
    [SET_STARTS_AT](state, payload) {
      state.starts_at = payload;
    },
    [SET_ENDS_AT](state, payload) {
      state.ends_at = payload;
    },
    [SET_ADDITIONAL_INFORMATIONS](state, payload) {
      state.additional_informations = payload;
    },
    [SET_USE_MY_PRODUCTS](state, payload) {
      state.use_my_products = payload;
    },
    [SET_PRICE](state, payload) {
      state.price = payload;
    },
    [SET_DISCOUNTED_PRICE](state, payload) {
      state.discounted_price = payload;
    },
    [SET_WONT_HAVE_INSTANT_SUPPORT](state, payload) {
      state.accept_wont_have_instant_support = payload;
    },
    [RESET_STATE](state) {
      Object.assign(state, getDefaultState());
    }
  },

  getters: {
    endsOnBusinessTime(state) {
      if (!state.ends_at) return false;

      let isAHoliday = eventHelper.isHoliday(state.day);
      if (isAHoliday) return;

      let weekDay = moment(state.day).day();
      let isAWeekend =
        weekDay === 0 || (weekDay === 6 && state.ends_at.substr(0, 2) > 12);

      return !isAWeekend;
    },

    isToday(state) {
      return (
        moment(state.day).format("YYYY-MM-DD") === moment().format("YYYY-MM-DD")
      );
    },
    canShowConfirmation(state) {
      return (
        state.professional && state.ends_at && state.additional_informations
      );
    },
    disabledHours(state) {
      let res = [];

      for (var hour = 7; hour < 22; hour++) {
        let start = state.starts_at
          ? parseInt(state.starts_at.substr(0, 2))
          : state.starts_at;
        if (start && (start > hour || start + 8 < hour)) res.push(hour);
      }

      return res;
    },
    labelDuration(state) {
      return !state.starts_at
        ? "selecione a hora inicial"
        : !state.ends_at
          ? "selecione a hora final"
          : parseInt(state.starts_at.substr(0, 2)) +
            "hrs às " +
            parseInt(state.ends_at.substr(0, 2)) +
            "hrs";
    },
    duration(state) {
      let res = 0;

      if (state.starts_at && state.ends_at) {
        let start = parseInt(state.starts_at.substr(0, 2));
        let end = parseInt(state.ends_at.substr(0, 2));

        res = end - start;
      }

      return res;
    },
    canGoToCheckout(state) {
      return state.address &&
        state.professional &&
        state.day &&
        state.starts_at &&
        state.ends_at &&
        state.price &&
        state.additional_informations
        ? true
        : false;
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/newOrder.js